import React, {useEffect, useRef, useState} from "react";
import { Button, Col, Divider, message, Modal, Row} from "antd";
import Watch from "../../../assets/logo/watch.png";
import "./Details.css";
import {
    CheckCircleFilled, CloseCircleFilled,
    ExclamationCircleFilled
} from "@ant-design/icons";
import {useLocation, useNavigate} from "react-router-dom";
import {ResumeDeleteSuspendRequestModel} from "../models/ResumeDeleteSuspendRequestModel";
import {submitResumeDeleteSuspendRequest} from "../service/SubscriptionService";
import ModalContent from "../../../constant/ModalContent";
import Indicator from "../../common/components/Indicator";
import Header from "../../../components/header/Header";



export default function Details(){
    const [visible, setVisible] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [isLoading,setIsLoading] = useState(false);
    // const [logMessage, setLogMessage] = useState(LogContent.DEVICE_DETAILED_PAGE);

    const location = useLocation();
    const navigate=useNavigate();
    const [selectedUser, setSelectedUser] = useState(location.state.data.selectedUser);

    const isMountedRef = useRef(false);

    const  mainUser  = location.state.data.mainUser;
    console.log(mainUser)

    const handleCancel = () => {
        setVisible(false);
        // setLogMessage(LogContent.DEVICE_DETAILED_PAGE);
        // isMountedRef.current = false;
        navigate("/manage-subscription/device-list")
    };

    const handleCancelWithCallBack = () => {
        // eslint-disable-next-line no-undef
        DataActivationController.doneSelected()
        setVisible(false);
        // setLogMessage(LogContent.DEVICE_DETAILED_PAGE);
        // isMountedRef.current = false;
    };

    const handleDeleteSuspendWithCallBack=()=> {
        // eslint-disable-next-line no-undef
        DataActivationController.dataPlanAccountCancelled()
    }

    const handleResumeWithCallBack=(response)=>{
        console.log(response);
        let paramsWithMeid = {
            eid: response.eid,
            iccid: response.iccid
        };

        // eslint-disable-next-line no-undef
        DataActivationController.dataPlanAccountUpdatedWithInfo(paramsWithMeid);
    }

    const handleResumeSuspendOkModal=(response)=>{
        setVisible(true);
        // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", `${selectedUser.status==="Active"?"Suspend":"Reactivate"} Confirmation`).replace("{{page}}", LogContent.DEVICE_DETAILED_PAGE_MESSAGE));
        // isMountedRef.current = false;
        if(selectedUser.status !== "Active"){
            handleResumeWithCallBack(response);
        }else{
            handleDeleteSuspendWithCallBack();
        }
        setModalContent(
            <>
                <CheckCircleFilled/>
                <h3>{selectedUser.status==="Active"?"Suspend":"Reactivate"} Confirmation</h3>
                <p>{ModalContent.SUSPEND_RESUME_DELETE_CONNECTION_CONFIRMATION_MESSAGE.replace("{{action}}",selectedUser.status==="Active"?"suspension":"reactivation" )} </p>
                <Divider/>
                <Button
                    className="okButton2"
                    type="text"
                    onClick={handleCancelWithCallBack}
                >
                    OK
                </Button>
            </>
        );
    }

    const handleSuspendResumeModal= ()=>{
            setVisible(true);
            // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", `${selectedUser.status==="Active"?"Suspend":"Reactivate"} Service`).replace("{{page}}", LogContent.DEVICE_DETAILED_PAGE_MESSAGE));
            // isMountedRef.current = false;
            setModalContent(
                <>
                    <ExclamationCircleFilled />
                    <h3>{selectedUser.status==="Active"?"Suspend":"Reactivate"} Service</h3>
                    <p>{ModalContent.SUSPEND_RESUME_SERVICE_MESSAGE.replace("{{action}}",selectedUser.status==="Active"?"suspended":"reactivated")} </p>
                    <Divider />
                    <Row>
                        <Col
                            span={12}
                            className="first-col"
                        >
                            <Button
                                className="cancelButton"
                                type="text"
                                onClick={handleCancel}
                            >
                                Cancel
                            </Button>
                        </Col>
                        <Col span={12}
                        >
                            <Button
                                danger
                                className="confirmButton"
                                type="text"
                                onClick={handleResumeSuspendConfirm}
                                disabled={isLoading}
                            >
                                Confirm
                            </Button>
                        </Col>
                    </Row>
                </>
            )
    }


    const handleResumeSuspendConfirm=async ()=>{
        setIsLoading(true);
        try{
            const resumeDeleteSuspendRequestModel:ResumeDeleteSuspendRequestModel={
                "request-id":getUniqueId(),
                action:{
                    name:"CS_PSState",
                    value:selectedUser.status==="Active"?"0":"1"
                },
                primaryMsisdn:mainUser.msisdn,
                primaryIccid:mainUser.iccid,
                primaryImsi:mainUser.imsi,
                msisdn:selectedUser.msisdn,
                iccid:selectedUser.iccid,
                imsi:selectedUser.imsi,
                eid:selectedUser.eid,
                nickName:selectedUser.nickName
            }
            console.log(resumeDeleteSuspendRequestModel);
            const response=await submitResumeDeleteSuspendRequest(resumeDeleteSuspendRequestModel);
            setIsLoading(false);
            if(response.resultCode===6000){
                const newStatus = selectedUser.status === "Active" ? "Suspended" : "Active";
                const updatedUser = { ...selectedUser, status: newStatus };
                setSelectedUser(updatedUser);
                handleResumeSuspendOkModal(response);
            }else if (response.resultCode === 6401){
                navigate("/");
                message.error(response.resultDesc,1)
            }else{
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Error Occurred").replace("{{page}}", LogContent.DEVICE_DETAILED_PAGE_MESSAGE));
                // isMountedRef.current = false;
                setModalContent(
                    <>
                        <CloseCircleFilled/>
                        <h2>Error</h2>
                        <p>{response.resultDesc}</p>
                        <Divider/>
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancel}
                        >
                            OK
                        </Button>
                    </>
                )
            }
        }catch(error){
            setIsLoading(false);
            message.error(ModalContent.GENERAL_ERROR_DESCRIPTION,1);
            throw new Error(error);
        }
    }

    const getUniqueId = () => {
        const min = 0;
        const max = 100;
        const rand = Math.floor(Math.random() * (max - min + 1) + min);
        console.log(rand);
        return rand;
    };


    const handleDeleteConfirm=async ()=>{
        setIsLoading(true);
        try{
            const resumeDeleteSuspendRequestModel:ResumeDeleteSuspendRequestModel={
                "request-id":getUniqueId(),
                action:{
                    name:"eSIMAction",
                    value:"0"
                },
                primaryMsisdn:mainUser.msisdn,
                primaryIccid:mainUser.iccid,
                primaryImsi:mainUser.imsi,
                msisdn:selectedUser.msisdn,
                iccid:selectedUser.iccid,
                imsi:selectedUser.imsi,
                eid:selectedUser.eid,
                nickName:selectedUser.nickName
            }
            console.log(resumeDeleteSuspendRequestModel);
            const response=await submitResumeDeleteSuspendRequest(resumeDeleteSuspendRequestModel);
            setIsLoading(false);
            if(response.resultCode===6000){
                const updatedUser = {...selectedUser, status: "Deleted"};
                setSelectedUser(updatedUser);
                handleDeleteOkModal();
            }else if (response.resultCode === 6403){
                navigate("/");
                message.error(response.resultDesc,1)
            }else{
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Error Occurred").replace("{{page}}", LogContent.DEVICE_DETAILED_PAGE_MESSAGE));
                // isMountedRef.current = false;
                setModalContent(
                    <>
                        <CloseCircleFilled/>
                        <h2>Error</h2>
                        <p>{response.resultDesc}</p>
                        <Divider/>
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancel}
                        >
                            OK
                        </Button>
                    </>
                )
            }
        }catch(error){
            setIsLoading(false);
            message.error(ModalContent.GENERAL_ERROR_DESCRIPTION,1);
            throw new Error(error);
        }
    }
    const handleDeleteModal=()=>{
        setVisible(true);
        // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Delete Active SIM").replace("{{page}}", LogContent.DEVICE_DETAILED_PAGE_MESSAGE));
        // isMountedRef.current = false;
        setModalContent(
            <>
                <ExclamationCircleFilled />
                <h3>Delete Active SIM</h3>
                <p>{ModalContent.DELETE_SERVICE_MESSAGE}</p>
                <Divider />
                <Row>
                    <Col
                        span={12}
                        className="first-col"
                    >
                        <Button
                            className="cancelButton"
                            type="text"
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                    </Col>
                    <Col span={12}
                    >
                        <Button
                            className="confirmButton"
                            danger
                            type="text"
                            onClick={handleDeleteConfirm}
                            disabled={isLoading}
                        >
                            Confirm
                        </Button>
                    </Col>
                </Row>
            </>
        )
    }


    const handleDeleteOkModal=()=>{
        setVisible(true);
        // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Delete Confirmation").replace("{{page}}", LogContent.DEVICE_DETAILED_PAGE_MESSAGE));
        // isMountedRef.current = false;
        handleDeleteSuspendWithCallBack();
        setModalContent(
            <>
                <CheckCircleFilled/>
                <h3>Delete Confirmation</h3>
                <p>{ModalContent.SUSPEND_RESUME_DELETE_CONNECTION_CONFIRMATION_MESSAGE.replace("{{action}}","Deletion")}</p>
                <Divider/>
                <Button
                    className="okButton2"
                    type="text"
                    onClick={handleCancelWithCallBack}
                >
                    OK
                </Button>

            </>
        );
    }

    useEffect(() => {

        // if (!isMountedRef.current) {
        //     isMountedRef.current = true;
        //
        //     const payload = {
        //         level: "INFO",
        //         timestamp: new Date().toISOString(),
        //         pageName: LogContent.DEVICE_DETAILED_PAGE,
        //         message: logMessage
        //     };
        //
        //     submitWebSheetLogCollection(payload)
        //         .then(() => {
        //             console.log('Log submitted successfully');
        //         })
        //         .catch(error => {
        //             console.error('Error submitting log:', error);
        //         });
        // }

    }, []);

    return(
        <>
            <div style={{backgroundColor:"#E6E6E6",width:"100%"}}>
                <Header/>
            </div>

            {isLoading && <Indicator />}

            <Row className="my-row">
                <Col className="first-col" span={8}>Hello!</Col>
                <Col className="second-sol" span={12}>{mainUser.msisdn}</Col>
            </Row>

            <div className="detailsDiv">
                <Row>
                    <Col className="detail-watch-col" span={2}>
                        <img src={Watch} alt="Apple Watch" className="appleWatchPic" />
                    </Col>
                    <Col className="dialog-col" span={10}>
                        <b>Dialog</b>
                    </Col>
                </Row>
                <p className="details-para">
                    ICCID
                    <span style={{marginLeft:"50px"}}>
                        {selectedUser.iccid}
                    </span>
                    <p className="status-span">
                        {selectedUser.status} SIM
                    </p>
                </p>

                {selectedUser.status !== "Deleted" &&(
                    <Row className="button-row1">
                        <Col span={12} className="first-col1">
                            <Button
                                shape="round"
                                className="detailsButton"
                                onClick={handleDeleteModal}
                                style={{ borderColor: "#f13434",color:"#f13434"}}
                            >
                                DELETE
                            </Button>
                        </Col>
                        <Col span={12} className="first-col2">
                            <Button
                                type="primary"
                                shape="round"
                                className="detailsButton1"
                                onClick={handleSuspendResumeModal}
                                style={{ backgroundColor: "#f13434"}}
                            >
                                {selectedUser.status === 'Active' ? 'SUSPEND' : 'REACTIVATE'}
                            </Button>
                        </Col>
                    </Row>
                )}

            </div>

            <Modal
                open={visible}
                onCancel={handleCancel}
                footer={null}
                closable={false}
            >
                {modalContent}
            </Modal>

        </>
    )
}